import React, { useState, useEffect, useContext, useCallback } from "react";
import { getTipos, createTipo, updateTipo, deleteTipo } from "../api";
import { AuthContext } from "../AuthContext";
import { Pencil, Trash2 } from "lucide-react";

export default function Tipos() {
  const { user } = useContext(AuthContext);

  const [tipos, setTipos] = useState([]);
  const [descricao, setDescricao] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingList, setLoadingList] = useState(true);
  const [msg, setMsg] = useState(null);

  // 🔹 Buscar tipos
  const fetchTipos = useCallback(async () => {
    setLoadingList(true);
    try {
      const data = await getTipos(user.token);
      setTipos(data);
    } catch (error) {
      setMsg({ type: "error", text: error.message });
    } finally {
      setLoadingList(false);
    }
  }, [user.token]);

  useEffect(() => {
    fetchTipos();
  }, [fetchTipos]);

  // 🔹 Criar / Atualizar
  async function handleSubmit(e) {
    e.preventDefault();
    setMsg(null);

    if (!descricao.trim()) {
      setMsg({ type: "error", text: "Descrição é obrigatória." });
      return;
    }

    setLoading(true);

    try {
      if (editingId) {
        await updateTipo(editingId, user.token, { descricao });
        setMsg({ type: "success", text: "Tipo atualizado!" });
      } else {
        await createTipo(user.token, { descricao });
        setMsg({ type: "success", text: "Tipo criado!" });
      }

      setDescricao("");
      setEditingId(null);
      fetchTipos(); // 🔥 atualiza lista
    } catch (error) {
      setMsg({ type: "error", text: error.message });
    } finally {
      setLoading(false);
    }
  }

  // 🔹 Editar
  function handleEdit(tipo) {
    setDescricao(tipo.descricao);
    setEditingId(tipo.id);
    setMsg(null);
  }

  function handleCancelEdit() {
    setDescricao("");
    setEditingId(null);
  }

  // 🔹 Deletar
  async function handleDelete(id) {
    if (!window.confirm("Deseja excluir este tipo?")) return;

    try {
      await deleteTipo(user.token, id);
      setMsg({ type: "success", text: "Tipo excluído!" });
      setTipos(prev => prev.filter(t => t.id !== id));
    } catch (error) {
      setMsg({ type: "error", text: error.message });
    }
  }

return (
  <div className="page-container">
    <div className="dashboard-container">
      <div className="user-card" style={{ maxWidth: "900px", margin: "0 auto" }}>

        {/* Cabeçalho */}
        <div style={{ 
          justifyContent: "space-between", 
          alignItems: "center", 
          marginBottom: "2rem" 
        }}>
          <h3>{editingId ? "Editar Tipo" : "Novo Tipo"}</h3>
        </div>

        {/* ==================== FORMULÁRIO ==================== */}
        <div className="item-row add-row" style={{ marginBottom: "2.5rem", gridTemplateColumns: "1fr 1fr auto" }}>
          <div className="item-input" style={{ gridColumn: "span 2" }}>
            <label>Descrição do Tipo</label>
            <input
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder="Ex: Atacado, Varejo, Distribuidor, Revenda..."
              className="input-text"
            />
          </div>

          <div className="item-actions">
            <button 
              type="button"
              className="btn-small"
              onClick={handleSubmit}
              disabled={loading || !descricao.trim()}
            >
              {loading ? (
                <>
                  <span className="spinner" style={{ marginRight: "8px" }}></span>
                  Salvando...
                </>
              ) : editingId ? (
                "Salvar Alterações"
              ) : (
                "Cadastrar Tipo"
              )}
            </button>
            {editingId && (
            <button 
              type="button" 
              className="btn-small"
              onClick={handleCancelEdit}
            >
              Cancelar Edição
            </button>
          )}
          </div>
        </div>

        {/* Mensagem de feedback */}
        {msg && (
          <div 
            className={msg.type === "error" ? "error-msg" : "success-msg"} 
            style={{ marginBottom: "2rem" }}
          >
            {msg.text}
          </div>
        )}

        {/* ==================== LISTA DE TIPOS ==================== */}
        <div style={{ marginTop: "2rem" }}>
          <h3 style={{ marginBottom: "1.5rem" }}>Lista de Tipos</h3>

          {loadingList ? (
            <div className="center-content" style={{ padding: "3rem 0" }}>
              <div className="spinner"></div>
              <p>Carregando tipos...</p>
            </div>
          ) : (
            <div className="items-list">
              {tipos.length === 0 ? (
                <p style={{ 
                  opacity: 0.7, 
                  textAlign: "center", 
                  padding: "3rem 0",
                  fontSize: "1.05rem"
                }}>
                  Nenhum tipo cadastrado ainda.
                </p>
              ) : (
                tipos.sort((a, b) => b.id - a.id).map((t) => (
                  <div key={t.id}
                    className="item-row"
                    style={{
                      background: editingId === t.id ? "rgba(59, 130, 246, 0.12)" : undefined,
                      border: editingId === t.id ? "1px solid #3b82f6" : undefined,
                      gridTemplateColumns: "1fr auto"
                    }}
                  >

                    <div className="item-input">
                      <label>Descrição</label>
                      <input value={t.descricao} disabled />
                    </div>

                    <div className="item-actions">
                      <button
                        className="btn-small"
                        onClick={() => handleEdit(t)}
                        title="Editar Tipo"
                      >
                        <Pencil size={18} />
                      </button>

                      <button
                        className="btn-danger btn-small"
                        onClick={() => handleDelete(t.id)}
                        title="Excluir Tipo"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

      </div>
    </div>
  </div>
);
}